import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationIndividual4MasterReferenceData = createAsyncThunk(
  'stop/getVerificationIndividual4MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationIndividual4MasterReferenceSlice = createSlice({
  name: 'stop/verificationIndividual4MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationIndividual4MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationIndividual4MasterReferenceData.fulfilled]: (
      state,
      action
    ) => action.payload,
  },
});

export const { resetVerificationIndividual4MasterReference } =
  verificationIndividual4MasterReferenceSlice.actions;

export default verificationIndividual4MasterReferenceSlice.reducer;
